/**
 * variant-pre-order-message.js
 * Theme: Dawn. Loaded only for variant products, inside the product-level
 * pre-order block (release_date is set). See sections/main-product.liquid.
 *
 * SOLE JOB: when the selected variant is flagged pre-order (its <label>
 * carries the [data-preorder] marker, set in product-variant-options.liquid
 * from custom.pre_order_yes_no), change the add-to-cart button label to
 * "Pre-Order"; revert to Dawn's own label otherwise.
 *
 * This script does NOT touch the .custom-release-date-true message — that is
 * a PRODUCT-LEVEL element controlled entirely by Liquid (release_date +
 * checkoutblocks.trigger). Variant selection must not show/hide it.
 *
 * Dawn re-renders its own button <span> on variant change, so we don't write
 * to that span: we inject our own label span and hide Dawn's while active,
 * removing ours (and un-hiding Dawn's) on revert. No MutationObservers.
 * Skips the Shop Pay installments form.
 */
(function () {
  'use strict';

  var PREORDER_LABEL = 'Pre-Order';

  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    if (
      form.classList.contains('installment') ||
      form.closest('.installment') ||
      form.querySelector('shopify-payment-terms')
    ) {
      return;
    }
    setupForm(form);
  });

  function setupForm(form) {
    const scope = form.closest('section') || document;

    const render = function () {
      const isPreOrder = selectedVariantIsPreOrder(scope);

      // Button label via our own span (Dawn owns/rewrites its span).
      const themeSpan = getBtnSpan(form);
      if (!themeSpan) return;

      let ourSpan = form.querySelector('[data-pre-order-btn-label]');
      if (isPreOrder) {
        if (!ourSpan) {
          ourSpan = document.createElement('span');
          ourSpan.setAttribute('data-pre-order-btn-label', '');
          themeSpan.parentNode.insertBefore(ourSpan, themeSpan.nextSibling);
        }
        ourSpan.textContent = PREORDER_LABEL;
        ourSpan.style.display = '';
        themeSpan.style.display = 'none'; // hide Dawn's label; keep spinner intact
      } else {
        // Hand the button fully back to Dawn.
        themeSpan.style.display = '';
        if (ourSpan) ourSpan.remove();
      }
    };

    // Defer so Dawn's async button re-render lands before we act.
    const deferredRender = function () {
      setTimeout(render, 60);
    };

    scope.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"], select')) deferredRender();
    });

    scope.addEventListener('variant:change', deferredRender);
    scope.addEventListener('on:variant:change', deferredRender);
    document.addEventListener('variant:change', deferredRender);

    render(); // initial paint
  }

  // Pre-order when the selected variant's <label> carries [data-preorder].
  function selectedVariantIsPreOrder(scope) {
    const label = getSelectedLabel(scope);
    return !!label && label.hasAttribute('data-preorder');
  }

  // Dawn's button label span: first <span> inside .product-form__submit.
  function getBtnSpan(form) {
    const submit = form.querySelector('.product-form__submit');
    return submit ? submit.querySelector('span') : null;
  }

  function getSelectedLabel(scope) {
    const checked = scope.querySelector('input[type="radio"]:checked');
    if (!checked) return null;

    if (checked.id) {
      const byFor = scope.querySelector('label[for="' + CSS.escape(checked.id) + '"]');
      if (byFor) return byFor;
    }
    const wrapping = checked.closest('label');
    if (wrapping) return wrapping;

    const next = checked.nextElementSibling;
    if (next && next.matches('label')) return next;

    return null;
  }
})();